import serviceBase from '../../../../Services/serviceBase'

class ContactActions{

  getCountries = async () => {
   try {
    let url = `${window._env_.COMMUNITY_API_URL}/data/countries`
    const response = await serviceBase.get(url)
    return response.data
   } catch (error) {
    console.log("Error trying to fetch countries")
   }
  }
}

export default new  ContactActions()
